import defaultRequest from './request'
import { registerAPI } from './api'


export async function registerService(data: any) {
    return defaultRequest({
        url: registerAPI,
        data: {
            action: 'submit',
            params: {},
            ...data,
        },
        method: 'post'
    })
}